import React, { useState } from 'react'
import "./banner.css"
import BannerMainImg from "../../assets/main-img.png"
import BannerSubImg from "../../assets/sub-img.png"
import BannerSubImg2 from "../../assets/sub-img2.png"
import ComingSoonImg from "../../assets/coming-soon.png"

const BannerScreen = () => {
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const[videoNumber,setVideoNumber] = useState("1")
    return (
        <div className='banner-section'>
            <div className='banner-container'>
                <div className='banner-head'>
                    Unlock Your Wealth Potential
                </div>
                <div className='banner-sub-head'>Where Innovation Meets Opportunity</div>

                <div className='banner-main-media' onClick={() => setIsVideoPlaying(true)}>

                    {videoNumber==="1" ? 
                    <>
                {isVideoPlaying ? (
                        <iframe
                            src="https://player.vimeo.com/video/1066256105?autoplay=1&muted=0"
                           className='banner-main-video'
                        // style={{ width: "100%", maxWidth: "1100px", height: "450px" }}
                            frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowFullScreen
                            title="Vimeo Video"
                        ></iframe>
                    ) : (
                        <img src={BannerMainImg} alt="Banner" className='banner-main-img' />
                    )} </>:<>
                          <iframe
                            src="https://player.vimeo.com/video/1066256046?autoplay=1&muted=0"
                           className='banner-main-video'
                            frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowFullScreen
                            title="Vimeo Video"
                        ></iframe> 
                    </>
                }
                </div>

                 

                <div className='banner-sub-images'>
                    <div onClick={()=>{setVideoNumber("1");setIsVideoPlaying(true)}}>
                        <img src={BannerSubImg2} alt="" className='banner-sub-img' />
                        <div className='sub-img-desc'>Teaser</div>
                    </div>
                    <div onClick={()=>setVideoNumber("2")}>
                        <img src={BannerSubImg} alt="" className='banner-sub-img' />
                        <div className='sub-img-desc'>Introduction</div>
                    </div>
                    <div>
                        <img src={ComingSoonImg} alt="" className='banner-sub-img' />
                        <div className='sub-img-desc'>Super Node</div>
                    </div>
                    <div>
                        <img src={ComingSoonImg} alt="" className='banner-sub-img' />
                        <div className='sub-img-desc'>Technology</div>
                    </div>
                    <div>
                        <img src={ComingSoonImg} alt="" className='banner-sub-img' />
                        <div className='sub-img-desc'>How to Get Started</div>
                    </div>


                </div>
            </div>
        </div>
    )
}

export default BannerScreen
